import api from '@/api/jobPostingChannelAccount'

const state = {

}

const actions = {
  getJobPostingChannelAccountList (commit, params) {
    return api.getJobPostingChannelAccountList(params)
  },
  getJobPostingChannelAccount (commit, id) {
    return api.getJobPostingChannelAccount(id)
  },
  createJobPostingChannelAccount (context, data) {
    return api.createJobPostingChannelAccount(data)
  },
  updateJobPostingChannelAccount (context, { id, data }) {
    return api.updateJobPostingChannelAccount(id, data)
  },
  deleteJobPostingChannelAccount (context, id) {
    return api.deleteJobPostingChannelAccount(id)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
